var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClothRecolorActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1765879182543,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5109,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M763.6 125.8L646.8 67.4a32 32 0 0 0-14.3-3.4H199.6a32 32 0 0 0-14.3 3.4L68.5 125.8a8.15 8.15 0 0 0-4.4 7.2v179a8 8 0 0 0 8 8h120v376a8 8 0 0 0 8 8H512l128-192 0.1-192h120a8 8 0 0 0 8-8V132.9a8.17 8.17 0 0 0-4.5-7.1zM416 256a128.12 128.12 0 0 1-128-128h256a128.12 128.12 0 0 1-128 128z",
    fill: "#A3D7FF",
    "p-id": 5110
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M644.63 320C465.31 320 320 463.3 320 640s145.31 320 324.63 320h19.11c39.4 0.1 71.5-31.3 71.6-70.2a69.91 69.91 0 0 0-17.6-46.5c-18.8-21.2-28.2-45.6-26.8-68.8a112.77 112.77 0 0 1 5.5-27.5c2.8-8.2 7.9-18.8 15.9-23.4 2.1-1.2 3.9-1.8 7.8-1.8 6 0 14.3 1.5 24 3.2 15.11 2.7 33.91 6.1 56.41 6.1a222.87 222.87 0 0 0 28.3-1.8c1.2-0.2 2.3-0.3 3.5-0.5 81.71-11.9 138.12-86.9 126-167.4a144.33 144.33 0 0 0-7-27.6C905.56 405.6 782.55 319.9 644.63 320z",
    fill: "#006EFF",
    "p-id": 5111
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M609.93 445.3a34.9 34.4 0 1 0 69.8 0 34.9 34.4 0 1 0-69.8 0Z",
    fill: "#FFFFFF",
    "p-id": 5112
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M737.75 491.1a34.9 34.4 0 1 0 69.8 0 34.9 34.4 0 1 0-69.8 0Z",
    fill: "#FFFFFF",
    "p-id": 5113
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M482.12 491.1a34.9 34.4 0 1 0 69.8 0 34.9 34.4 0 1 0-69.8 0Z",
    fill: "#FFFFFF",
    "p-id": 5114
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M424.01 582.7a34.9 34.4 0 1 0 69.8 0 34.9 34.4 0 1 0-69.8 0Z",
    fill: "#FFFFFF",
    "p-id": 5115
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothRecolorActive);
export default __webpack_public_path__ + "static/media/clothRecolor_active.7d0b29edb481b390d390ad0cc3ccd018.svg";
export { ForwardRef as ReactComponent };